import { Progress } from "@heroui/react";

interface BlockWaitingProgressProps {
  currentBlock: number;
  targetBlock: number;
  label?: string;
}

export function BlockWaitingProgress({
  currentBlock,
  targetBlock,
  label = "Waiting for L2 block",
}: BlockWaitingProgressProps) {
  const blocksRemaining = Math.max(0, targetBlock - currentBlock);
  const progress = currentBlock >= targetBlock ? 100 : Math.min(99, ((currentBlock - (targetBlock - 100)) / 100) * 100);

  return (
    <div className="w-full space-y-2">
      <div className="flex items-center justify-between gap-2 text-sm">
        <span className="text-[#ADC0D0]">{label}</span>
        <span className="text-white font-medium whitespace-nowrap">
          {blocksRemaining === 0 ? "Ready" : `${blocksRemaining} blocks remaining`}
        </span>
      </div>
      <Progress
        value={progress}
        size="sm"
        aria-label={`${label}: ${blocksRemaining === 0 ? "Ready" : `${blocksRemaining} blocks remaining`}`}
        classNames={{
          base: "max-w-full",
          track: "bg-default-500/30",
          indicator: "bg-gradient-to-r from-violet-500 to-cyan-500",
        }}
      />
      <div className="flex items-center justify-between text-xs text-[#ADC0D0]">
        <span>Current: {currentBlock}</span>
        <span>Target: {targetBlock}</span>
      </div>
    </div>
  );
}
